import { useFirestoreID } from '../../firebase/useFirestore'

const ActivityMeta = ({id, inline = false}) => {

    const activities = useFirestoreID('Activities', id || '')

  return (
    <>
        {activities && activities.map((item) => (
            inline ? <span key={item.ID}>{item.Activity}</span> : <p key={item.ID}>{item.Activity}</p>
        ))}
    </>
  )
}

export default ActivityMeta
